module.exports = __webpack_public_path__ + "static/media/DAPC-2023-27.40cf756a.pdf";